import {
  Feedback,
  ParticipantStep,
  QuizSubmission,
  ResolutionStatus,
} from '@wix/ambassador-challenges-v1-participant/types';
import { IToastProviderProps } from '../ToastContext/interfaces';
import { useControllerData } from '../main/controllerContext';

export type ResolveStepParams = {
  stepId: string;
  feedback?: Feedback;
  status?: ResolutionStatus;
  errorMessage?: string;
  unresolvedMessage?: IToastProviderProps['toastMessage'];
  quizSubmission?: QuizSubmission;
  isUpdate?: boolean;
  /**
   * When true, skip toggling `isResolveStepRequestInProgress`. Callers use
   * this for fire-and-forget optimistic flows where the user has already
   * navigated away and shouldn't see loading feedback tied to this request.
   */
  background?: boolean;
};

export interface IResolveStepContext {
  isResolveStepRequestInProgress: boolean;
  resolveStep: (params: ResolveStepParams) => Promise<void>;
  resolveStepData: Pick<
    ParticipantStep,
    'id' | 'quizSubmission' | 'transitions'
  >;
  resolveStepError: string;
}

export const useResolveStep = () => {
  const props = useControllerData();
  return {
    isResolveStepRequestInProgress: props.isResolveStepRequestInProgress,
    resolveStep: props.resolveStep,
    resolveStepData: props.resolveStepData,
    resolveStepError: props.resolveStepError,
  };
};
